import React from "react";
import { PHONE } from "../mock";

const HERO_BG = "https://images.unsplash.com/photo-1567361808960-dec9cb578182";
const BUSINESS_CARD = "https://customer-assets-4nw71qhi.emergentagent.net/job_faithful-render-3/artifacts/nd30sq3o_dan%20handyman%20business%20card.webp";

const Hero = () => {
  return (
    <section id="home" className="dhs-hero" style={{ backgroundImage: `url(${HERO_BG})` }}>
      <div className="dhs-hero-overlay" />
      <div className="dhs-container dhs-hero-inner">
        <div className="dhs-hero-left">
          <h1 className="dhs-hero-title">
            LICENSED HOME<br />REPAIRS SPECIALIST
          </h1>
          <div className="dhs-hero-underline" />
          <p className="dhs-hero-text">
            Providing High Quality Handyman Services<br />In Utah Since 1983.
          </p>
          <a href={`tel:${PHONE}`} className="dhs-hero-btn">
            CALL {PHONE}
          </a>
        </div>
        <div className="dhs-hero-right">
          <img src={BUSINESS_CARD} alt="Dan's Handyman Services business card" className="dhs-card-img" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
